module.exports = __webpack_public_path__ + "Roboto-Medium.woff?7b225d4d9324ee54ce6d9ec50e339668";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/Medium/Roboto-Medium.woff?v=2.137
// module id = 678
// module chunks = 7